import { useCallback } from 'react';

import { useGraphql } from '../graphql';

// Saves the account's appearance (C27) and settles with the appearance the
// service then holds. expectedAccount is the account the choice was made
// under, which the service checks against whoever the browser's cookie now
// belongs to (#136).
export function useAppearanceChanges() {
  const graphql = useGraphql();

  return useCallback(function({ appearance, expectedAccount }) {
    return graphql({
      document: `mutation Appearance($input: ProfileInput!, $expectedAccount: ID) {
        updateProfile(input: $input, expectedAccount: $expectedAccount) { id profile { appearance } }
      }`,
      variables: { input: { appearance }, expectedAccount }
    }).then(function(data) {
      return data.updateProfile.profile.appearance;
    });
  }, [ graphql ]);
}
